<template>
	<div class="bank">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="$router.push('/buyer/company')">开票公司</el-button>
			<el-button type="primary" size="small" @click="onadd()">新增收款帐号</el-button>
		</div>
		<div class="tablebox">
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="ctype_str" fixed="left" label="账号类型" align="center" header-align="center">
					</el-table-column>
					<el-table-column align="center" header-align="center">
						<template slot="header" slot-scope="scope">
							<div>开票公司名称</div>
							<div>姓名</div>
						</template>
						<template slot-scope="scope">
							<div v-if="scope.row.ctype == 1">
								{{scope.row.invoice_company_arr.name}}
							</div>
							<div v-else>
								{{scope.row.nickname}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="纳税人识别号/电话/地址" align="center" header-align="center">
						<template slot-scope="scope">
							<div>
								{{scope.row.invoice_company_arr.nssbh}}
							</div>
							<div>
								{{scope.row.invoice_company_arr.mobile}}
							</div>
							<div>
								{{scope.row.invoice_company_arr.address}}
							</div>
						</template>
					</el-table-column>
					
					<el-table-column prop="khh" label="开户行" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="account" label="账号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)">编辑</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog :title="ruleForm.id == 0?'新增收款帐号':'编辑收款帐号'" :visible.sync="show" width="600px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
					<el-form-item label="账号类型" prop="ctype" v-if="ruleForm.id == 0">
						<el-radio-group v-model="ruleForm.ctype" @change="onradio">
							<el-radio :label="1">对公银行账号</el-radio>
							<el-radio :label="2">个人银行账户</el-radio>
							<el-radio :label="3">个人支付宝账号</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开票公司" prop="invoice_company" v-if="ruleForm.ctype == 1" class="myformitem">
						<el-select v-model="ruleForm.invoice_company" placeholder="请选择开票公司">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in kpgs"
								:key="k">
							</el-option>
						</el-select>
						<i class="i el-icon-circle-plus-outline" @click="onadd1()"></i>
					</el-form-item>
					<el-form-item label="姓名" prop="nickname" v-if="ruleForm.ctype == 2 || ruleForm.ctype == 3">
						<el-input v-model="ruleForm.nickname" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="开户银行" prop="khh" v-if="ruleForm.ctype == 1 || ruleForm.ctype == 2">
						<el-input v-model="ruleForm.khh" placeholder="请输入开户行"></el-input>
					</el-form-item>
					<el-form-item label="账户" prop="account">
						<el-input v-model="ruleForm.account" placeholder="请输入账户"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		<add ref="add" :type="2" @upadd="onkpgs()"></add>
	</div>
</template>

<script>
	export default {
		name: 'Bank',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				show: false,

				ruleForm: {
					id: 0,
					ctype: 1,
					invoice_company: "",
					nickname: "",
					khh: "",
					account: ""
				},

				rules: {
					ctype: [{
						required: true,
						message: '请选择账号类型',
						trigger: 'change'
					}],
					
					nickname: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					
					khh: [{
						required: true,
						message: '请输入开户行',
						trigger: 'blur'
					}],
					
					account: [{
						required: true,
						message: '请输入账户',
						trigger: 'blur'
					}],
					
					invoice_company: [{
						required: true,
						message: '请选择开票公司',
						trigger: 'change'
					}]
				},
				
				kpgs: []
			}
		},

		mounted() {
			this.onlist();
			this.onkpgs();
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onlist() {
				var obj = {};
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/user_bank_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onkpgs() {
				var obj = {};
				obj.page = 1;
				obj.limit = 1000;
				
				this.$axios.post('api/user/user_invoice_company_list', obj).then(res => {
					if (res.data.code == 0) {
						this.kpgs = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					id: 0,
					ctype: 1,
					invoice_company: "",
					nickname: "",
					khh: "",
					account: ""
				};
			},
			
			onradio() {
				this.ruleForm.invoice_company = "";
				this.ruleForm.nickname = "";
				this.ruleForm.khh = "";
				this.ruleForm.account = "";
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('api/user/user_bank_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onupdate(obj) {
				for (let key in this.ruleForm) {
					this.ruleForm[key] = obj[key];
				}
				this.show = true;
			},
			
			onadd1() {
				this.$refs.add.show1 = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.bank {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		height: 100%;
	}
	
	/deep/ .el-select {
		width: 400px;
	}
	
	/deep/ .el-input {
		width: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/bank.vue